import React from 'react';
import { Table } from '../../../UiKit';
import { ChevronDown, ChevronUp } from 'sushiweb/Icons';
import { getFullDate } from '../../commons/CommonMethods';

export const getFeatureTableTemplate = (
  item,
  isActive,
  message,
  getUsagesTable,
  getActiveState,
  openUsageTable,
) => {
  const detailsObj = {
    1: {
      title: item.feature_id || '-',
      nestedTable: isActive
        ? {
            colSpan: '5',
            data: <Table tableData={getUsagesTable()} message={message} />,
            show: true,
          }
        : null,
    },
    2: {
      title: item.added_by || '-',
      subtitle: item.added_on || '-',
    },
    3: {
      title: item.valid_till || '-',
    },
    4: {
      title: getActiveState(item) || '-',
    },
    5: {
      title:
        (
          <p className='pointer' onClick={openUsageTable(item)}>
            <span className='text_green'>{item.used?.name}</span>
            {isActive ? (
              <ChevronUp color='#50b547' />
            ) : (
              <ChevronDown color='#50b547' />
            )}
          </p>
        ) || '-',
    },
  };
  return detailsObj;
};

export const getUsagesTableTemplate = (item) => {
  const usageObj = {
    1: {
      title: item.order_id || '-',
    },
    2: {
      title: item.created_by || '-',
      subtitle: getFullDate(item.created_at) || '-',
    },
    3: {
      title: item.status || '-',
    },
    4: {
      title: item.transaction_id || '-',
    },
  };

  return usageObj;
};
